/*
 * KS Cart Drawer - tiroir panier maison (remplace UpCart). Aucune dépendance, aucun appel hors du domaine.
 * - intercepte les formulaires /cart/add, les fetch/XHR vers /cart/* des autres scripts, le lien panier du header ;
 * - re-rend la section "ks-cart-drawer" via la Section Rendering API ;
 * - ajoute/retire les cadeaux des paliers selon les consignes calculées en Liquid (data-ks-cart-state).
 */
(function () {
  'use strict';
  if (window.KSCart) return;

  var SECTION = 'ks-cart-drawer';
  var DISMISSED_KEY = 'ks-cart-dismissed-gifts';
  var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  var nativeFetch = window.fetch.bind(window);
  var queue = Promise.resolve();
  var el, panel, lastFocus;

  function url(path) { return root + path.replace(/^\//, ''); }

  function getDismissed() {
    try { return JSON.parse(sessionStorage.getItem(DISMISSED_KEY) || '[]'); } catch (e) { return []; }
  }
  function setDismissed(list) {
    try { sessionStorage.setItem(DISMISSED_KEY, JSON.stringify(list)); } catch (e) {}
  }

  /* Toutes les mutations passent par cette file : jamais deux requêtes panier en parallèle. */
  function enqueue(fn) {
    var p = queue.then(fn, fn);
    queue = p.catch(function () {});
    return p;
  }

  function request(path, body) {
    var isForm = body instanceof FormData;
    if (isForm) {
      body.append('sections', SECTION);
      body.append('sections_url', location.pathname);
    } else {
      body = Object.assign({}, body, { sections: SECTION, sections_url: location.pathname });
    }
    return nativeFetch(url(path), {
      method: 'POST',
      credentials: 'same-origin',
      headers: isForm
        ? { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-KS-Cart': '1' }
        : { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-KS-Cart': '1' },
      body: isForm ? body : JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok) {
          var err = new Error(data.message || 'Error');
          err.status = r.status;
          // Shopify renvoie une raison lisible et traduite (stock insuffisant...) dans "description"
          if (typeof data.description === 'string') err.description = data.description;
          throw err;
        }
        return data;
      });
    });
  }

  function fetchSection() {
    return nativeFetch(url('?sections=' + SECTION), { credentials: 'same-origin', headers: { 'X-KS-Cart': '1' } })
      .then(function (r) { return r.json(); });
  }

  function state() {
    var s = el && el.querySelector('[data-ks-cart-state]');
    try { return s ? JSON.parse(s.textContent) : null; } catch (e) { return null; }
  }

  /* Remplace le contenu du tiroir par le HTML rendu par Shopify. */
  function render(sections) {
    if (!sections || !sections[SECTION]) return;
    var doc = new DOMParser().parseFromString(sections[SECTION], 'text/html');
    var fresh = doc.getElementById('KsCartInner');
    var inner = document.getElementById('KsCartInner');
    if (!fresh || !inner) return;
    var body = inner.querySelector('[data-ks-body]');
    var scroll = body ? body.scrollTop : 0;
    // la note en cours de saisie ne doit pas être écrasée par le rendu serveur
    var note = inner.querySelector('[data-ks-note]');
    var noteVal = note ? note.value : null;
    var noteOpen = note ? note.closest('details').open : false;
    inner.innerHTML = fresh.innerHTML;
    var nn = inner.querySelector('[data-ks-note]');
    if (nn && noteVal !== null) { nn.value = noteVal; if (noteOpen) nn.closest('details').open = true; }
    var nb = inner.querySelector('[data-ks-body]');
    if (nb) nb.scrollTop = scroll;
    var st = state();
    if (st) updateCount(st.count);
  }

  function updateCount(count) {
    document.querySelectorAll('.header__cart-count, [data-cart-count], .cart-count-bubble span').forEach(function (n) {
      n.textContent = count;
    });
    document.documentElement.dispatchEvent(new CustomEvent('ks-cart:updated', { detail: { count: count } }));
  }

  function showError(msg) {
    var box = el && el.querySelector('[data-ks-error]');
    if (!box) return;
    box.textContent = msg;
    box.hidden = false;
    clearTimeout(showError.t);
    showError.t = setTimeout(function () { box.hidden = true; }, 10000);
  }

  function setLoading(on) {
    if (el) el.classList.toggle('is-loading', !!on);
  }

  /* Ajoute / retire les cadeaux jusqu'à ce que le panier soit cohérent (max 3 passes). */
  function reconcile(pass) {
    pass = pass || 0;
    var st = state();
    if (!st || pass > 2) return Promise.resolve();
    var dismissed = getDismissed();
    // un palier perdu "oublie" le refus du client : s'il le reprend, le cadeau revient
    var keep = dismissed.filter(function (id) { return st.reached.indexOf(id) !== -1; });
    if (keep.length !== dismissed.length) setDismissed(keep);

    var adds = st.add.filter(function (g) { return keep.indexOf(g.product) === -1; });
    var updates = {};
    st.remove.forEach(function (k) { updates[k] = 0; });
    st.fix.forEach(function (k) { updates[k] = 1; });
    var hasUpdates = Object.keys(updates).length > 0;
    if (!adds.length && !hasUpdates) return Promise.resolve();

    var step = hasUpdates
      ? request('cart/update.js', { updates: updates })
      : request('cart/add.js', {
          items: adds.map(function (g) {
            return { id: g.id, quantity: 1, properties: { _ks_gift: String(g.tier) } };
          })
        });
    return step.then(function (data) {
      render(data.sections);
      return reconcile(pass + 1);
    }).catch(function () { /* un cadeau en rupture ne doit pas bloquer le panier */ });
  }

  function mutate(path, body, opts) {
    opts = opts || {};
    return enqueue(function () {
      setLoading(true);
      return request(path, body)
        .then(function (data) {
          render(data.sections);
          return reconcile().then(function () {
            if (opts.open) open();
            return data;
          });
        })
        .catch(function (err) {
          var msg = err.description || (el && el.dataset.errorText) || err.message;
          return refresh().catch(function () {}).then(function () {
            if (opts.open) open();
            showError(msg);
          });
        })
        .finally(function () { setLoading(false); });
    });
  }

  function refresh(openAfter) {
    return fetchSection().then(function (sections) {
      render(sections);
      return reconcile();
    }).then(function () { if (openAfter) open(); });
  }

  function open() {
    if (!el || el.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ks-cart-lock');
    setTimeout(function () { panel && panel.focus({ preventScroll: true }); }, 50);
    document.documentElement.dispatchEvent(new CustomEvent('ks-cart:open'));
  }

  function close() {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ks-cart-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- Interceptions ---------- */

  function isCartPage() { return /\/cart\/?$/.test(location.pathname); }

  // Formulaires produit (Warehouse en mode "page" les soumet nativement)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!el || !form || !form.action || !/\/cart\/add/.test(form.getAttribute('action') || form.action)) return;
    if (form.hasAttribute('data-ks-skip')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var fd = new FormData(form);
    if (e.submitter && e.submitter.name) fd.append(e.submitter.name, e.submitter.value);
    if (!fd.get('quantity')) fd.set('quantity', '1');
    var btn = e.submitter || form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    mutate('cart/add.js', fd, { open: el.dataset.openOnAdd !== 'false' }).finally(function () {
      if (btn) { btn.removeAttribute('aria-busy'); btn.removeAttribute('disabled'); }
    });
  }, true);

  // Lien / icône panier du header
  document.addEventListener('click', function (e) {
    if (!el || isCartPage()) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.closest('#KsCartDrawer')) return;
    var href = a.getAttribute('href') || '';
    var path = href.split('?')[0].split('#')[0];
    if (/^(https?:\/\/[^/]+)?\/([a-z]{2}(-[a-z]{2})?\/)?cart\/?$/i.test(path) || a.hasAttribute('data-ks-open-cart')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
    }
  }, true);

  // Appels panier faits par d'autres scripts (configurateur, apps) : on suit et on ouvre sur un ajout
  function watchCartCall(u, method) {
    if (!u || typeof u !== 'string') return null;
    var m = u.match(/\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/);
    if (!m || (method || 'GET').toUpperCase() !== 'POST') return null;
    return m[1];
  }

  window.fetch = function (input, init) {
    var u = typeof input === 'string' ? input : (input && input.url) || '';
    var method = (init && init.method) || (input && input.method) || 'GET';
    var hdrs = (init && init.headers) || {};
    var ours = hdrs instanceof Headers ? hdrs.get('X-KS-Cart') : hdrs['X-KS-Cart'];
    var kind = ours ? null : watchCartCall(u, method);
    var p = nativeFetch(input, init);
    if (kind) {
      p.then(function (r) {
        if (r.ok) enqueue(function () { return refresh(kind === 'add' && el && el.dataset.openOnAdd !== 'false'); });
      }).catch(function () {});
    }
    return p;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, u) {
    var kind = watchCartCall(String(u), method);
    if (kind) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          enqueue(function () { return refresh(kind === 'add' && el && el.dataset.openOnAdd !== 'false'); });
        }
      });
    }
    return xhrOpen.apply(this, arguments);
  };

  /* ---------- Actions dans le tiroir ---------- */

  function bindDrawer() {
    el.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-ks-close]')) { e.preventDefault(); close(); return; }

      var rm = t.closest('[data-ks-remove]');
      if (rm) {
        var gp = rm.getAttribute('data-ks-gift-product');
        if (gp) {
          var d = getDismissed();
          if (d.indexOf(+gp) === -1) d.push(+gp);
          setDismissed(d);
        }
        mutate('cart/change.js', { id: rm.getAttribute('data-ks-remove'), quantity: 0 });
        return;
      }

      var q = t.closest('[data-ks-qty]');
      if (q) {
        mutate('cart/change.js', { id: q.getAttribute('data-ks-qty'), quantity: Math.max(0, parseInt(q.getAttribute('data-qty'), 10) || 0) });
        return;
      }

      var add = t.closest('[data-ks-upsell-add]');
      if (add) {
        var card = add.closest('[data-ks-upsell]');
        var v = card.querySelector('[data-ks-upsell-variant]');
        add.setAttribute('aria-busy', 'true');
        mutate('cart/add.js', { items: [{ id: +v.value, quantity: 1 }] });
        return;
      }

      var nav = t.closest('[data-ks-upsell-nav]');
      if (nav) {
        var track = el.querySelector('[data-ks-upsell-track]');
        if (track) {
          var dir = +nav.getAttribute('data-ks-upsell-nav');
          var w = track.clientWidth;
          var max = track.scrollWidth - w;
          var next = track.scrollLeft + dir * w;
          if (next > max + 5) next = 0;
          if (next < -5) next = max;
          track.scrollTo({ left: next, behavior: 'smooth' });
        }
      }
    });

    el.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-ks-qty-input]')) {
        mutate('cart/change.js', { id: t.getAttribute('data-ks-qty-input'), quantity: Math.max(0, parseInt(t.value, 10) || 0) });
      } else if (t.matches('select[data-ks-upsell-variant]')) {
        var opt = t.options[t.selectedIndex];
        var price = t.closest('[data-ks-upsell]').querySelector('[data-ks-upsell-price]');
        if (price && opt) price.innerHTML = opt.getAttribute('data-price');
      }
    });

    var noteTimer;
    el.addEventListener('input', function (e) {
      if (!e.target.matches('[data-ks-note]')) return;
      var v = e.target.value;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        nativeFetch(url('cart/update.js'), {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-KS-Cart': '1' },
          body: JSON.stringify({ note: v })
        }).catch(function () {});
      }, 600);
    });

    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-ks-qty-input]')) { e.preventDefault(); e.target.blur(); }
    });

    el.addEventListener('submit', function () {
      var b = el.querySelector('[data-ks-checkout]');
      if (b) b.setAttribute('aria-busy', 'true');
    });
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  // bfcache (retour arrière) : le panier a pu changer dans un autre onglet / au checkout
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) enqueue(function () { return refresh(false); });
  });

  // Pas d'écoute de "cart:refresh" : le thème l'émet à chaque affichage de page (requête inutile) ;
  // les ajouts du configurateur sont déjà suivis par l'interception de fetch ci-dessus.

  function init() {
    el = document.getElementById('KsCartDrawer');
    if (!el) return;
    panel = el.querySelector('.ks-cart__panel');
    bindDrawer();
    enqueue(function () { return reconcile(); });
  }

  window.KSCart = {
    open: open,
    close: close,
    refresh: function (o) { return enqueue(function () { return refresh(o); }); },
    add: function (items, o) { return mutate('cart/add.js', { items: items }, { open: !o || o.open !== false }); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
